<template>
  <div class="spl-modal-holder spl-modal-holder-show">
    <div class="spl-modal">
      <div class="spl-modal__close" @click="closeScanner" />
      <div v-show="isLoading">
        <p>Scanning module is loading up...</p>
        <p>Please grant camera access otherwise scanning won't work</p>
      </div>
      <div v-show="!isLoading">
        <video ref="scanner" poster="data:image/gif,AAAA" />
      <!-- <div class="laser" /> -->
      </div>
    </div>
  </div>
</template>

<script>
import { BrowserBarcodeReader, Exception } from '@zxing/library'
export default {
  name: 'StreamBarcodeReader',
  data () {
    return {
      isLoading: true,
      codeReader: new BrowserBarcodeReader(),
      isMediaStreamAPISupported:
                navigator &&
                navigator.mediaDevices &&
                'enumerateDevices' in navigator.mediaDevices
    }
  },
  mounted () {
    if (!this.isMediaStreamAPISupported) {
      throw new Exception('Media Stream API is not supported')
    }
    this.start()
  },
  beforeDestroy () {
    this.codeReader.reset()
  },
  methods: {
    start () {
      this.codeReader.decodeFromVideoDevice(
        undefined,
        this.$refs.scanner,
        (result) => {
          this.isLoading = false
          if (result) {
            this.$emit('decode', result.text)
          }
        }
      )
    },
    closeScanner () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
video {
    max-width: 100%;
    max-height: 100%;
    margin-top: 40px;
}
.scanner-container {
    position: relative;
}
.overlay-element {
    position: absolute;
    top: 0;
    width: 100%;
    height: 99%;
    background: rgba(30, 30, 30, 0.5);
    -webkit-clip-path: polygon(
        0% 0%,
        0% 100%,
        20% 100%,
        20% 20%,
        80% 20%,
        80% 80%,
        20% 80%,
        20% 100%,
        100% 100%,
        100% 0%
    );
    clip-path: polygon(
        0% 0%,
        0% 100%,
        20% 100%,
        20% 20%,
        80% 20%,
        80% 80%,
        20% 80%,
        20% 100%,
        100% 100%,
        100% 0%
    );
}
.laser {
    width: 60%;
    margin-left: 20%;
    background-color: tomato;
    height: 1px;
    position: absolute;
    top: 40%;
    z-index: 2;
    box-shadow: 0 0 4px red;
    -webkit-animation: scanning 2s infinite;
    animation: scanning 2s infinite;
}
@-webkit-keyframes scanning {
    50% {
        -webkit-transform: translateY(75px);
        transform: translateY(75px);
    }
}
@keyframes scanning {
    50% {
        -webkit-transform: translateY(75px);
        transform: translateY(75px);
    }
}
</style>
